// ==========================================
// API Constants
// ==========================================
export const API_ENDPOINTS = {
    HEALTH: "/api/health",
    PROJECTS: "/api/projects",
    PROJECT_SESSIONS: (name) => `/api/projects/${encodeURIComponent(name)}/sessions`,
    SESSION_MESSAGES: (id) => `/api/sessions/${encodeURIComponent(id)}/messages`,
    SESSION_COUNT: (id) => `/api/sessions/${encodeURIComponent(id)}/count`,
    SEARCH: "/api/search",
    STATS_PROJECT: (name) => `/api/stats/project/${encodeURIComponent(name)}`,
    STATS_SESSION: (id) => `/api/stats/session/${encodeURIComponent(id)}`,
    STATS_SUMMARY: (name) => `/api/stats/summary/${encodeURIComponent(name)}`,
};
// ==========================================
// Pagination Constants
// ==========================================
export const DEFAULT_PAGE_SIZE = 100;
export const MAX_PAGE_SIZE = 500;
// ==========================================
// File Constants
// ==========================================
export const CLAUDE_FOLDER_NAME = ".claude";
export const PROJECTS_FOLDER_NAME = "projects";
export const JSONL_EXTENSION = ".jsonl";
// ==========================================
// UI Constants
// ==========================================
export const MESSAGE_TYPES = {
    USER: "user",
    ASSISTANT: "assistant",
    SYSTEM: "system",
    SUMMARY: "summary",
};
export const CONTENT_TYPES = {
    TEXT: "text",
    TOOL_USE: "tool_use",
    TOOL_RESULT: "tool_result",
    THINKING: "thinking",
};
// ==========================================
// Error Messages
// ==========================================
export const ERROR_MESSAGES = {
    CLAUDE_FOLDER_NOT_FOUND: "Claude folder not found. Please ensure Claude Code is installed.",
    PERMISSION_DENIED: "Permission denied. Please check file permissions.",
    INVALID_PATH: "Invalid path provided.",
    API_ERROR: "API request failed.",
    NETWORK_ERROR: "Network error. Please check your connection.",
    UNKNOWN: "An unknown error occurred.",
};
// ==========================================
// Default Configuration
// ==========================================
export const DEFAULT_CONFIG = {
    PORT: 3000,
    HOST: "localhost",
    CLAUDE_PATH: "~/.claude",
};
//# sourceMappingURL=index.js.map